import * as React from 'react';

import Container from '../containers/LoginSsosp';

const LoginSsosp: React.FC<any> = props => {
	return <Container {...props} />;
};

export default LoginSsosp;



// WEBPACK FOOTER //
// ./src/pages/LoginSsosp.tsx